import {StyleSheet} from 'react-native';

import {denim} from '/theme/color/on.color';
import {codGray, mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
  },
  headerContainerLargeFont: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  icon: {
    color: denim,
    fontSize: 15,
    marginRight: 6,
    alignSelf: 'center',
  },
  headerText: {
    color: codGray,
    fontWeight: 'bold',
    flex: 2,
    fontSize: 15,
  },
  sideText: {
    color: mineShaft,
    flex: 1,
    marginLeft: 8,
  },
  sideTextLargeFont: {
    width: '100%',
    marginTop: 4,
  },
  link: {
    color: denim,
    fontWeight: '600',
    maxWidth: 120,
  },
  content: {
    marginTop: 8,
  },
  bannerHeight: {
    minHeight: 265,
  },
});
